export default __webpack_public_path__ + "98d4230c9e7fdeb529bc225d273b0fe1.png";